import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const RatingsRedux = createActions({
  RatingsExcelRequest: [''],
  RatingsExcelSuccess: [''],
  RatingsExcelError: ['error'],
},
{
  prefix: 'RATINGS_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = RatingsRedux
export const RatingsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const RatingsExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const RatingsExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const RatingsExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.RatingsExcelRequest]: RatingsExcelRequest,
  [Types.RatingsExcelSuccess]: RatingsExcelSuccess,
  [Types.RatingsExcelError]: RatingsExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/RatingsRedux.js